var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoTractorCamionVerde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 64 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.093,
    cy: 32.093,
    r: 20.093,
    fill: "#008000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5999 27H42.5999C42.821 27 43 27.179 43 27.3999V35.7998C43 35.9059 42.9578 36.0076 42.8828 36.0827L42.0828 36.8826C42.0078 36.9577 41.9061 36.9998 41.8 37H38.9432C38.7993 37.5651 38.3579 38.0065 37.7926 38.1504C36.9404 38.3672 36.0737 37.8522 35.8568 37H24.1432C23.9993 37.5651 23.5579 38.0065 22.9927 38.1504C22.1405 38.3672 21.2738 37.8522 21.0568 37H19.4001C19.179 37 19 36.8208 19 36.5999V33.2399C18.9997 33.0039 19.0693 32.7733 19.2 32.5767L20.4281 30.7344C20.6509 30.4001 21.0262 30.1994 21.4281 30.1999H25C25.2209 30.1999 25.4001 30.3791 25.4001 30.5999V34.5999H26.2V27.3999C26.2 27.179 26.3791 27 26.5999 27ZM23 31H22.2V32.5999H23V31ZM21.4001 31.0036C21.277 31.0116 21.1646 31.076 21.0952 31.1779L20.1471 32.5999H21.4001V31.0036ZM21.8 36.5999C21.8 37.0418 22.1582 37.3999 22.5999 37.3999C23.0418 37.3999 23.4001 37.0418 23.4001 36.5999C23.4001 36.158 23.0418 35.8 22.5999 35.8C22.1582 35.8 21.8 36.158 21.8 36.5999ZM25.4001 36.1999H27V35.3999H25.4001V36.1999ZM27.8 36.1999H28.5999V35.3999H27.8V36.1999ZM36.2363 35.5088C36.2577 35.486 36.2788 35.464 36.3013 35.4427C36.3078 35.4365 36.314 35.4298 36.3202 35.423C36.3274 35.415 36.3348 35.407 36.3428 35.3999H29.4001V36.2H35.8507C35.8693 36.1307 35.8924 36.0627 35.9199 35.9964C35.9212 35.9932 35.9222 35.9899 35.9233 35.9865C35.9245 35.9827 35.9257 35.9788 35.9272 35.9753C35.9645 35.8896 36.0091 35.8075 36.0607 35.7297C36.07 35.7155 36.08 35.7021 36.0901 35.6888C36.0965 35.6802 36.103 35.6716 36.1092 35.6628C36.1484 35.6089 36.1909 35.5575 36.2363 35.5088ZM36.5999 36.5999C36.5999 37.0418 36.9582 37.3999 37.4001 37.3999C37.8418 37.3999 38.2 37.0418 38.2 36.5999C38.2 36.158 37.8418 35.8 37.4001 35.8C36.9582 35.8 36.5999 36.158 36.5999 36.5999ZM41.6344 36.1999L42.2 35.6344V35.3999H38.4588C38.4646 35.4056 38.4701 35.4119 38.4758 35.4183C38.4832 35.4266 38.4907 35.4351 38.4989 35.4427C38.5212 35.4639 38.5425 35.486 38.5636 35.5088C38.6092 35.5575 38.6517 35.6089 38.6909 35.6628C38.6969 35.6711 38.703 35.6793 38.7091 35.6875C38.7194 35.7013 38.7297 35.715 38.7393 35.7295C38.7909 35.8073 38.8356 35.8895 38.8729 35.9751C38.8743 35.9785 38.8754 35.9821 38.8765 35.9858C38.8776 35.9894 38.8787 35.993 38.88 35.9964C38.9076 36.0627 38.9308 36.1305 38.9492 36.1999H41.6344ZM39.3998 28.6H38.5998V33.8H39.3998V28.6ZM34.5998 28.6H33.7998V33.8H34.5998V28.6ZM28.9998 28.6H29.7998V33.8H28.9998V28.6Z",
    fill: "#FBFDFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 3,
    y: 5,
    width: 60.186,
    height: 60.186,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoTractorCamionVerde);
export default __webpack_public_path__ + "static/media/iconoTractorCamionVerde.e04a17e86155756fe44c56b375887ff7.svg";
export { ForwardRef as ReactComponent };